/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID, FINDER_THEMES_CREATE_REQUEST, FINDER_THEMES_CREATE_RECEIVE, FINDER_THEMES_CREATE_ERROR, FINDER_THEMES_CREATE_CHILD_REQUEST, FINDER_THEMES_CREATE_CHILD_RECEIVE, FINDER_THEMES_CREATE_CHILD_ERROR, FINDER_THEMES_CREATE_CHILD_RESET, FINDER_THEMES_DUPLICATE_REQUEST, FINDER_THEMES_DUPLICATE_RECEIVE, FINDER_THEMES_DUPLICATE_ERROR, FINDER_THEMES_FETCH_CHILD_THEMES, FINDER_THEMES_CHILD_ADD_FILE_REQUEST, FINDER_THEMES_CHILD_ADD_FILE_RECEIVE, FINDER_THEMES_CHILD_ADD_FILE_ERROR, FINDER_ASSETS_CHILD_ADD_FILE_RESET, FINDER_FETCH_THEMES } from 'DesignData/actions/ActionTypes';
import CopyStatus from 'DesignData/enums/CopyStatus';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import { setActiveProjectFolderId } from 'DesignData/actions/finder/Projects';
import * as themesClient from 'DesignData/api/finder/Themes';
import * as portalCopyClient from 'DesignData/api/PortalCopy';
import { getCopyStatus } from 'DesignData/api/PortalCopy';
import * as finderSelectors from 'DesignData/selectors/finder';
import * as FolderAssetTypes from 'DesignData/constants/FolderAssetTypes';
import { pollApi } from 'DesignData/lib/polling';
import { validateChildThemeFilesLength } from 'DesignData/lib/validation';
import { every } from 'underscore';
import { BLANK_THEME_NAME } from 'DesignData/constants/Themes';
import { isThemeRootFolder } from 'DesignData/lib/themes/themes';
import { getThemePathFromFolder, getThemePathFromFile } from 'DesignData/selectors/finder';
export function setActiveThemeFolderId(folderId = null) {
  return dispatch => {
    if (folderId) {
      dispatch(setActiveProjectFolderId(null));
    }

    dispatch({
      type: FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID,
      folderId
    });
  };
}
export function createChildTheme({
  themeName,
  folderPath,
  parentThemeId,
  baseThemeFolder,
  childCSSName,
  childJSName
}) {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = createChildTheme;

    if (!validateChildThemeFilesLength(themeName, FolderAssetTypes.THEME) || !validateChildThemeFilesLength(childCSSName, FolderAssetTypes.CSS) || !validateChildThemeFilesLength(childJSName, FolderAssetTypes.JS)) {
      const __error = {
        status: 'error',
        errorCategory: 'MAX_LENGTH'
      };
      return dispatch(error(__error));
    }

    const name = themeName;
    const path = folderPath.length ? `/${folderPath.join('/')}/${themeName}` : `/${themeName}`;
    const parentThemePath = `/${baseThemeFolder.fullPath}`;
    let jsPath = `/child.js`;

    if (childJSName.length) {
      jsPath = `/${childJSName}.js`;
    }

    let cssPath = `/child.css`;

    if (childCSSName.length) {
      cssPath = `/${childCSSName}.css`;
    }

    const state = getState();
    const rootFolderId = finderSelectors.getRootFolderId(state);
    const parentFolderId = parentThemeId || rootFolderId;
    const folder = finderSelectors.getFolder(state, {
      folderId: parentFolderId
    });

    if (!folder) {
      const referenceError = new ReferenceError(`Unable to find folder with ID '${parentFolderId}.`);
      return dispatch(error(referenceError));
    }

    const handleSuccess = theme => {
      dispatch(receive(theme));
      const fetchAction = parentFolderId === rootFolderId ? FoldersActions.fetchRootFolderContents : FoldersActions.fetchContents;
      dispatch(fetchAction(parentFolderId)).then(() => {
        dispatch(FoldersActions.fetchContents(theme.folderId));
      });
    };

    const handleError = __error => {
      dispatch(error(__error));
    };

    dispatch(request());
    return themesClient.createChildTheme(name, path, parentThemePath, jsPath, cssPath).then(creationId => {
      pollApi(themesClient.getCreationStatus, creationId, {
        statusProp: 'status',
        success: CopyStatus.COMPLETE,
        failure: CopyStatus.FAILED,
        onSuccess: handleSuccess,
        onFailure: handleError,
        onError: handleError
      });
    }).catch(handleError);
  };
}

createChildTheme.request = () => {
  return {
    type: FINDER_THEMES_CREATE_CHILD_REQUEST,
    status: CopyStatus.IN_PROGRESS
  };
};

createChildTheme.receive = theme => {
  return {
    type: FINDER_THEMES_CREATE_CHILD_RECEIVE,
    status: CopyStatus.COMPLETE,
    theme
  };
};

createChildTheme.error = error => {
  return {
    type: FINDER_THEMES_CREATE_CHILD_ERROR,
    status: CopyStatus.FAILED,
    error
  };
};

export function resetChildThemeCreationCopyStatus() {
  return {
    type: FINDER_THEMES_CREATE_CHILD_RESET
  };
}
export const fetchThemes = () => dispatch => {
  return themesClient.getThemes().then(({
    objects: themes
  }) => dispatch({
    type: FINDER_FETCH_THEMES,
    themes
  }));
};
export function fetchChildThemes(asset) {
  const {
    request,
    receive,
    error
  } = fetchChildThemes;
  return (dispatch, getState) => {
    let parentThemePath = getThemePathFromFile(getState())(asset);

    if (asset.type === FolderAssetTypes.FOLDER) {
      parentThemePath = getThemePathFromFolder(getState())(asset);
    }

    dispatch(request(parentThemePath, true));
    return themesClient.getChildThemes(parentThemePath).then(response => {
      if (response.childThemes.length > 0) {
        const childThemes = response.childThemes;
        dispatch(receive(childThemes, false));
      } else {
        dispatch(receive(null, false));
      }
    }).catch(__error => {
      dispatch(error(__error, false));
    });
  };
}

fetchChildThemes.request = (parentThemePath, isFetchingChildThemes) => {
  return {
    type: FINDER_THEMES_FETCH_CHILD_THEMES,
    parentThemePath,
    isFetchingChildThemes
  };
};

fetchChildThemes.receive = (childThemes, isFetchingChildThemes) => {
  return {
    type: FINDER_THEMES_FETCH_CHILD_THEMES,
    childThemes,
    isFetchingChildThemes
  };
};

fetchChildThemes.error = (error, isFetchingChildThemes) => {
  return {
    type: FINDER_THEMES_FETCH_CHILD_THEMES,
    error,
    isFetchingChildThemes
  };
};

export function copyParentThemeFile(asset, childTheme, destinationPortalId, onCopySuccess) {
  const {
    request,
    receive,
    error
  } = copyParentThemeFile;
  let sourcePath = asset.path;

  if (asset.type === FolderAssetTypes.CUSTOM_WIDGET) {
    sourcePath = `${asset.path}.module`;
  }

  if (asset.type === FolderAssetTypes.FOLDER) {
    sourcePath = asset.fullPath;
  }

  const parentPathLength = childTheme.extends.length;
  const relPath = sourcePath.slice(parentPathLength);
  const destinationPath = `${childTheme.path}${relPath}`;
  const requestedAssets = [{
    sourcePath,
    destinationPath,
    destinationPortalId
  }];

  function fetchNestedFolders(dispatch, getState, folderId) {
    return dispatch(FoldersActions.fetchContents(folderId)).then(() => {
      const getFolderContents = finderSelectors.makeGetFolderContents();
      const folderContents = getFolderContents(getState(), {
        folderId
      });
      const subfolders = folderContents.subfolders.map(id => fetchNestedFolders(dispatch, getState, id));
      Promise.all(subfolders);
    });
  }

  return (dispatch, getState) => {
    dispatch(request(asset.id));

    const handleSuccess = resp => {
      fetchNestedFolders(dispatch, getState, childTheme.folderId).then(() => {
        onCopySuccess(resp);
        dispatch(receive(asset.id));
      });
    };

    const handleError = response => {
      const __error = Object.values(response.responseJSON)[0];
      dispatch(error(asset.id, __error));
    };

    return portalCopyClient.bulkCopyToPortal(requestedAssets, []).then(response => {
      const copyId = Object.values(response.requestedAssetCopyIds);
      pollApi(portalCopyClient.getBulkCopyStatus, copyId, {
        statusProp: 'status',
        success: CopyStatus.COMPLETE,
        failure: CopyStatus.FAILED,
        onSuccess: handleSuccess,
        onFailure: handleError,
        onError: handleError,
        getStatus: resp => {
          const statuses = Object.values(resp).map(a => a.status);
          if (every(statuses, s => s === CopyStatus.COMPLETE)) return CopyStatus.COMPLETE;
          if (every(statuses, s => s === CopyStatus.COMPLETE || s === CopyStatus.FAILED)) return CopyStatus.FAILED;
          return CopyStatus.IN_PROGRESS;
        }
      });
    }).catch(__error => {
      dispatch(error(asset.id, __error));
    });
  };
}

copyParentThemeFile.request = assetId => {
  return {
    type: FINDER_THEMES_CHILD_ADD_FILE_REQUEST,
    assetId,
    status: CopyStatus.IN_PROGRESS
  };
};

copyParentThemeFile.receive = assetId => {
  return {
    type: FINDER_THEMES_CHILD_ADD_FILE_RECEIVE,
    assetId,
    status: CopyStatus.COMPLETE
  };
};

copyParentThemeFile.error = (assetId, error) => {
  return {
    type: FINDER_THEMES_CHILD_ADD_FILE_ERROR,
    assetId,
    error,
    status: CopyStatus.FAILED
  };
};

export function resetParentThemeFileCopyStatus() {
  return {
    type: FINDER_ASSETS_CHILD_ADD_FILE_RESET
  };
}
export function createTheme({
  themePath,
  themeName,
  folderPath,
  label,
  folderId: __parentFolderId,
  onThemeCreateSuccess,
  onThemeCreateFailure
}) {
  const {
    request,
    receive,
    error
  } = createTheme;
  return (dispatch, getState) => {
    const state = getState();
    const rootFolderId = finderSelectors.getRootFolderId(state);
    const parentFolderId = __parentFolderId || rootFolderId;
    const folder = finderSelectors.getFolder(state, {
      folderId: parentFolderId
    });

    if (!folder) {
      const referenceError = new ReferenceError(`Unable to find folder with ID '${parentFolderId}.`);
      return dispatch(error(referenceError));
    }

    const destinationFolderPath = `${folderPath.join('/')}/${themeName}`;

    const handleSuccess = theme => {
      const fetchAction = parentFolderId === rootFolderId ? FoldersActions.fetchRootFolderContents : FoldersActions.fetchContents;
      onThemeCreateSuccess(theme);
      dispatch(fetchAction(parentFolderId)).then(() => {
        dispatch(FoldersActions.fetchContents(theme.folderId)).then(() => {
          dispatch(receive(theme, themePath));
        });
      });
      dispatch(fetchThemes());
    };

    const handleError = __error => {
      const {
        status,
        responseJSON,
        errorCategory: category,
        errorContext: context
      } = __error;

      if (!responseJSON && status === 'FAILED') {
        __error = Object.assign({}, __error, {
          responseJSON: {
            category,
            context
          }
        });
      }

      dispatch(error(__error));
      onThemeCreateFailure(__error, themeName);
    };

    dispatch(request());

    if (themePath === BLANK_THEME_NAME) {
      return themesClient.createTheme({
        label,
        destinationFolderPath
      }).then(handleSuccess).catch(handleError);
    } else {
      return themesClient.copyDefaultThemeByPath(themePath, {
        label,
        destinationFolderPath
      }).then(copyId => {
        pollApi(getCopyStatus, copyId, {
          statusProp: 'status',
          success: CopyStatus.COMPLETE,
          failure: CopyStatus.FAILED,
          onSuccess: handleSuccess,
          onFailure: handleError,
          onError: handleError
        });
      }).catch(handleError);
    }
  };
}

createTheme.request = function createThemeRequest() {
  return {
    type: FINDER_THEMES_CREATE_REQUEST
  };
};

createTheme.receive = function createThemeReceive(theme, baseTheme) {
  return {
    type: FINDER_THEMES_CREATE_RECEIVE,
    theme,
    baseTheme
  };
};

createTheme.error = function createThemeError(error) {
  return {
    type: FINDER_THEMES_CREATE_ERROR,
    error
  };
};

function duplicateThemeRequest() {
  return {
    type: FINDER_THEMES_DUPLICATE_REQUEST
  };
}

function duplicateThemeReceive(theme) {
  return {
    type: FINDER_THEMES_DUPLICATE_RECEIVE,
    theme
  };
}

function duplicateThemeError(error) {
  return {
    type: FINDER_THEMES_DUPLICATE_ERROR,
    error
  };
}

export function duplicateTheme({
  baseThemeFolder,
  themeName,
  folderPath,
  folderId: __parentFolderId,
  onThemeCreateSuccess,
  onThemeCreateFailure
}) {
  return (dispatch, getState) => {
    if (!isThemeRootFolder(baseThemeFolder)) {
      throw new Error(`Invalid base theme folder passed to duplicateTheme. id: ${baseThemeFolder && baseThemeFolder.id} path: ${baseThemeFolder && baseThemeFolder.fullPath}`);
    }

    const state = getState();
    const rootFolderId = finderSelectors.getRootFolderId(state);
    const parentFolderId = __parentFolderId || rootFolderId;
    dispatch(duplicateThemeRequest());
    const destinationFolderPath = `${folderPath.join('/')}/${themeName}`;

    const handleError = __error => {
      const {
        status,
        responseJSON,
        errorCategory: category,
        errorContext: context
      } = __error;

      if (!responseJSON && status === 'FAILED') {
        __error = Object.assign({}, __error, {
          responseJSON: {
            category,
            context
          }
        });
      }

      dispatch(duplicateThemeError(__error));
      onThemeCreateFailure(__error, themeName);
    };

    const handleSuccess = theme => {
      const fetchAction = parentFolderId === rootFolderId ? FoldersActions.fetchRootFolderContents : FoldersActions.fetchContents;
      dispatch(fetchAction(parentFolderId)).then(() => {
        dispatch(FoldersActions.fetchContents(theme.folderId)).then(() => {
          dispatch(duplicateThemeReceive(theme));
        });
      });
      onThemeCreateSuccess(theme);
    };

    return themesClient.copyDefaultThemeByPath(baseThemeFolder.fullPath, {
      destinationFolderPath,
      label: themeName
    }).then(copyId => {
      pollApi(getCopyStatus, copyId, {
        statusProp: 'status',
        success: CopyStatus.COMPLETE,
        failure: CopyStatus.FAILED,
        onSuccess: handleSuccess,
        onFailure: handleError,
        onError: handleError
      });
    }).catch(handleError);
  };
}